import React from "react";
import { useQuery } from "@apollo/react-hooks";

import Layout from "components/Layout";
import DataTable, { mapData } from "components/DataTable";
import LineChart from "components/chart/LineChart";
import Scrollable from "components/Scrollable";
import withAuth from "components/withAuth";
import { H1, H2, P, Section } from "../styles";
import { AVERAGE } from "../queries";

function Age() {
  const { data: { average } = { average: [] } } = useQuery(AVERAGE);
  const years = Object.keys(average);
  const perYearAggregation = {};
  const perYearAverage = {};
  const perYearAgeGap = {};

  Object.values(average).map(
    ({ aggregation }: any, index) =>
      (perYearAggregation[years[index]] = aggregation)
  );

  Object.values(average).map(
    ({ average }: any, index) => (perYearAverage[years[index]] = average)
  );

  Object.values(average).map(
    ({ gap }: any, index) => (perYearAgeGap[years[index]] = gap)
  );

  const aggregationData = mapData(perYearAggregation, true);
  const averageData = mapData(perYearAverage, true);
  const ageGapData = mapData(perYearAgeGap, true);

  return (
    <Layout>
      <Section>
        <H1>Average Age Per Year Aggregation</H1>
        <P>The average age aggregation per year through the time.</P>
        <DataTable headers={["", "Year", "Average"]} data={averageData} />
      </Section>
      <Section>
        <H1>Average Age Per Year</H1>
        <P>The average age per year.</P>
        <DataTable
          headers={["", "Year", "Aggregation"]}
          data={aggregationData}
        />
      </Section>
      <Section>
        <H1>Average Age Gap Per Year</H1>
        <P>The average age gap per year.</P>
        <DataTable headers={["", "Year", "Age Gap"]} data={ageGapData} />
      </Section>
      <Section>
        <H2>Line Chart</H2>
        <P>The average age per year in a line chart.</P>
        {averageData && (
          <Scrollable>
            <LineChart data={averageData} />
          </Scrollable>
        )}
      </Section>
      <Section>
        <H2>Line Chart</H2>
        <P>The average age aggregation per year in a line chart.</P>
        {aggregationData && (
          <Scrollable>
            <LineChart data={aggregationData} />
          </Scrollable>
        )}
      </Section>
    </Layout>
  );
}

export default withAuth(Age);
